import type { IArboristTreeNode } from '../models/Interfaces';

export function findPageTreeMatches(nodes: IArboristTreeNode[], query: string): string[] {
  const term = query.trim().toLocaleLowerCase();
  if (!term) return [];
  const ids: string[] = [];
  const visit = (items: IArboristTreeNode[]) => {
    for (const node of items) {
      const alias = node.alias ?? node.url?.split('/').filter(Boolean).pop() ?? '';
      if (node.type.toLowerCase() === 'page' &&
          (node.name.toLocaleLowerCase().includes(term) || alias.toLocaleLowerCase().includes(term))) ids.push(node.id);
      visit(node.children ?? []);
    }
  };
  visit(nodes);
  return ids;
}
